import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { subjectsByIDandCourse } from '../../../../http/coursesAPI';
import Header from '../../../../components/Headers/Header';
import ChatApp from '../../../../components/ChatApp/ChatApp';
import styles from './courses.module.scss';
import './darkMode.css';
import defaulImage from '../../../../assets/images/BoostDarkLogo.svg';
import { Context } from '../../../..';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'; // Импортируем кастомный спиннер

function CoursesPage() {
  const { subject_id } = useParams();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      const userCourses = user.user.purchased_courses;
      try {
        const data = await subjectsByIDandCourse(subject_id);
        const filteredData = data.filter((course) =>
          userCourses.includes(course.id),
        );
        setCourses(filteredData);
      } catch (error) {
        console.error('Error fetching courses:', error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [subject_id]);

  return (
    <><Header className="mt-4" />
      <div className={`${styles.container} px-6`}>
        {/* Хедер всегда остается видимым */}

        {/* Вставляем кастомный спиннер, если контент грузится */}
        {loading ? (
          <div className="loading-container">
            <LoadingSpinner isLoading={loading} />
          </div>
        ) : (
          <div>
            <div className={`${styles.title} mt-16 mb-8`}>
              <h2>Доступные курсы</h2>
            </div>

            {courses.length > 0 ? (
              <div className="flex flex-wrap gap-4">
                {courses.map((course) => (
                  <div
                    className="shrink-0 basis-[100%] sm:basis-[278px] bg-lavender-8 rounded-2xl p-2"
                    key={course.id}
                    onClick={() =>
                      navigate(`/themes`, {
                        state: { courseId: course.id },
                      })
                    }
                  >
                    <div className="w-full min-h-[123px] bg-lavender rounded-xl overflow-hidden">
                      <img className="object-cover" src={course.image_url} alt={course.title} />
                    </div>
                    <div className="py-4 px-2 leading-5">
                      <h4 className="font-semibold">{course.title}</h4>
                      <p className="opacity-50">{course.description || ''}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>В данном разделе пока нет курсов.</p>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default CoursesPage;
